import React from 'react';

import { RCLoadingBars } from '@reverbdotcom/cadence/components';
import { ILegacyApiShippingRegion } from '@reverbdotcom/commons/src/shipping/shipping_region_selector';

import { V3 } from '../api_request';
import UrlHelpers from './url_helpers';
import EditShippingRatesForm from './edit_shipping_rates_form';
import { FormContext } from './edit_shipping_rate_card';
import { IShippingRate } from './edit_shipping_rate_card_manual_prices';
import { core_apimessages_ShippingLabelPackage } from '../../schemas/rql';

export interface IProps {
  formContext: FormContext;
  shippingRates: IShippingRate[];
  currency: string;
  allowedToShipExpedited?: boolean;
  allowedToShipCarrierCalculated?: boolean;
  inCarrierCalculatedMode?: boolean;
  allowedToSetRegionalShipping?: boolean;
  showInternationalRegions?: boolean;
  setIsInCarrierCalculatedMode?: (boolean) => void;
  shopAddressSummary?: string;
  shippingPackage?: core_apimessages_ShippingLabelPackage;
}

export function EditShippingRatesFormContainer({
  currency,
  shippingRates,
  formContext,
  allowedToShipExpedited = false,
  allowedToShipCarrierCalculated = false,
  inCarrierCalculatedMode = false,
  allowedToSetRegionalShipping = false,
  setIsInCarrierCalculatedMode,
  showInternationalRegions = false,
  shopAddressSummary,
  shippingPackage,
}: IProps) {
  const [areShippingRegionsLoaded, setAreShippingRegionsLoaded] = React.useState(false);
  const [shippingRegions, setShippingRegions] = React.useState<ILegacyApiShippingRegion[]>([]);

  React.useEffect(() => {
    V3.get(UrlHelpers.shippingRegionsPath).done((response) => {
      setShippingRegions(response.shipping_regions);
      setAreShippingRegionsLoaded(true);
    });
  }, [setShippingRegions]);

  if (!areShippingRegionsLoaded) {
    return (
      <div className="scaling-padding-2 d-flex fx-justify-center bg-white">
        <RCLoadingBars size="large" />
      </div>
    );
  }

  return (
    <EditShippingRatesForm
      currency={currency}
      allowedToShipExpedited={allowedToShipExpedited}
      shippingRates={shippingRates}
      shippingRegionOptions={shippingRegions}
      formContext={formContext}
      allowedToShipCarrierCalculated={allowedToShipCarrierCalculated}
      inCarrierCalculatedMode={inCarrierCalculatedMode}
      allowedToSetRegionalShipping={allowedToSetRegionalShipping}
      setIsInCarrierCalculatedMode={setIsInCarrierCalculatedMode}
      showInternationalRegions={showInternationalRegions}
      shopAddressSummary={shopAddressSummary}
      shippingPackage={shippingPackage}
    />
  );
}

export default EditShippingRatesFormContainer;
